.productCard {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.productCardContainer {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
}

.productCardImage {
  aspect-ratio: 1;
}

.productCardImage img {
  cursor: pointer;
  border-radius: var(--card-border-radius);
}

.productCardImage div {
  cursor: pointer;
}

.productCardImage.focus-visible:focus-visible::before {
  inset: 2px;
  border-radius: var(--card-border-radius);
  z-index: 1;
}

.productCardPrice {
  display: flex;
  align-items: center;
  margin-top: auto;
  gap: 4px;
}

.productCardDealsText {
  color: var(--colors-info-main);
}

.productCardPriceMultipleWeights {
  flex-direction: column;
  align-items: baseline;
}

.textContrastColor {
  color: var(--colors-text-inverse);
}

.productCardPopoverHeader {
  margin-bottom: 32px;
  position: relative;
}

.productCardPopoverHeader > button {
  position: absolute;
  top: -10px;
}

.priceAndAddToCartContainer {
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  margin-top: 2px;
  gap: 4px;
}

.productCardAddToCartForm {
  margin-top: 4px;
}

.addToCartButton {
  padding-left: 8px;
  padding-right: 8px;
  text-wrap: nowrap;
}

.badges {
  display: flex;
  position: absolute;
  flex-wrap: wrap;
  justify-content: flex-end;
  top: 8px;
  right: 8px;
  gap: 7px;
  z-index: 1;
}

.janeGoldBadge > p {
  font-size: 15px;
}

/* Mid-grid placement card variant */
.productCardPlacement {
  background-color: var(--colors-grays-white);
  border-radius: var(--card-border-radius);
}

.productCardPlacement .productCardImage {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.productCardPlacement .productCardImage img {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.productCardPlacement .priceAndAddToCartContainer {
  padding: 0 8px 8px;
}
